import React, { Fragment, useEffect } from "react";
import { connect } from "react-redux";
import { Breadcrumbs, Card, CardContent, Chip, Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { setCurrentPage, getSaitamaOverview, setSaitamaChartSize } from "actions";
import * as C from "components";
import * as V from "styles/variables";
import SingleSelect from "components/Select/SingleSelect";
import PhotoShootSaitama from "components/PicTree/Home/PhotoShootSaitama";
import LineChartPictreePhotoShoot from "components/Charts/LineChartPictreePhotoShoot";
import PicTreeTablePhotoShootNtt from "components/Table/PicTreeTablePhotoShootNtt";
import ChartConfig from "utils/ChartConfig";
import CalendarRangePicTreeSaitama from "components/Calendar/CalendarRangePicTreeSaitama";

const useStyles = makeStyles((theme) => ({
  breadcrumbs: { marginTop: 16, minHeight: 30 },
  gridSection: { marginTop: theme.spacing(1) },
  noData: { display: "flex", justifyContent: "center", alignItems: "center", minHeight: 280 },
}));

const chartConfig = {
  countDenchu: "総基数",
  unique: "ユニーク撮影者数",
  newUser: "初回撮影者数",
};

const PicTreeReviewSummarySaitama = ({
  setCurrentPage,
  selectedSeason,
  dateRange,
  chartSize,
  overview,
  setSaitamaChartSize,
  getSaitamaOverview,
}) => {
  const classes = useStyles();
  useEffect(() => { setCurrentPage(window.location.pathname); }, [setCurrentPage]);
  useEffect(() => { getSaitamaOverview(); }, [dateRange, chartSize, getSaitamaOverview]);
  const trend = overview.photoShootTrend || [];
  const loading = overview.status === "loading";
  return (
    <Fragment>
      <C.ContentWrapper>
        <Grid container spacing={0} direction="row" style={{ marginTop: -16, marginBottom: 8 }} justifyContent="space-between">
          <Grid item>
            <Breadcrumbs separator="›" className={classes.breadcrumbs}>
              <Typography>さいたま市</Typography><Typography variant="body1">撮影</Typography><Typography variant="body1">概要</Typography>
            </Breadcrumbs>
          </Grid>
          <Grid item><CalendarRangePicTreeSaitama /></Grid>
        </Grid>
        <Grid container spacing={0} style={{ marginTop: 0 }}><Grid item xs={12}><Card><CardContent><PhotoShootSaitama homeDataPhotoShoot={overview.homeDataPhotoShoot} selectedSeason={selectedSeason} /></CardContent></Card></Grid></Grid>
        <Grid container spacing={0} direction="row" style={{ marginTop: 16, marginRight: 16, marginBottom: 8 }} justifyContent="space-between">
          <Grid item style={{ marginTop: 0, marginLeft: 48 }}><SingleSelect selected={{ name: chartSize === "hour" ? "時間別" : "日別", value: chartSize }} options={[{ name: "時間別", value: "hour" }, { name: "日別", value: "day" }]} handleChange={event => setSaitamaChartSize(event.target.value)} /></Grid>
        </Grid>
        <Grid container spacing={1} className={classes.gridSection}><Grid item xs={12}>
          {loading ? <div className={classes.noData}><img width="40" src="/static/images/loader-bar.gif" alt="loading" /></div> : trend.length > 0 ? <LineChartPictreePhotoShoot legend={["総基数", "ユニーク撮影者数", "初回撮影者数"]} lblSaveImage="" xAisData={trend[0].date} seriesData={trend} chartType="line" chartConfig={chartConfig} colorValue={ChartConfig.kpiSalesLegendColor} /> : <div className={classes.noData}><Chip label="No Data" style={{ color: V.textColor, backgroundColor: V.placeholderColor }} /></div>}
        </Grid></Grid>
        <Grid container spacing={1} className={classes.gridSection}><Grid item xs={12}><PicTreeTablePhotoShootNtt photoShootTrend={trend} game="PicTree" chartSize={chartSize} rowLabels={["総基数", "ユニーク撮影者数", "初回撮影者数"]} unsupportedValue="-" filename="PicTree - さいたま市撮影トレンドデータ" /></Grid></Grid>
      </C.ContentWrapper>
    </Fragment>
  );
};

const mapStateToProps = state => ({
  selectedSeason: state.pictreeSaitama.selectedSeason,
  dateRange: state.pictreeSaitama.dateRange,
  chartSize: state.pictreeSaitama.chartSize,
  overview: state.pictreeSaitama.overview,
});

const mapDispatchToProps = dispatch => ({
  setCurrentPage: value => dispatch(setCurrentPage(value)),
  getSaitamaOverview: () => dispatch(getSaitamaOverview()),
  setSaitamaChartSize: value => dispatch(setSaitamaChartSize(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PicTreeReviewSummarySaitama);
